import * as React from "react";
import ISvgProps from "../../../SvgLoader/ISvgProps";
function SvgInPerson(props: ISvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="11 11 38 38"
      fill="none"
      {...props}
    >
      <circle
        cx={29.358}
        cy={22.5}
        r={8}
        stroke={props.primaryColor}
        strokeWidth={3}
      />
      <path
        stroke={props.primaryColor}
        strokeWidth={3}
        d="M28.238 32.5h3.524c7.34 0 13.335 5.756 13.718 13H14.52c.383-7.244 6.379-13 13.718-13Z"
      />
    </svg>
  );
}
export default SvgInPerson;
